/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

const Params = z.strictObject({ requestId: z.string().min(1) });

export const JiraRequestsCommentsPost = {
  id: 'jira-request-comments.post',
  tag: 'Support',
  summary: 'Create Jira request comments',
  description: 'Create jira request comment',
  method: 'post',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/jira/request/${params.requestId}/comments`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            body: z.string(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            id: z.string(),
            name: z.string(),
            avatar: z.string(),
            body: z.string(),
            createdAt: z.string(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
